const addAutosizePlugin = ($: JQueryStatic) => {
  // temporary stub for replacing $.autosize plugin
  // this will be removed once the jQuery usage is removed
  $.fn.extend({
    autosize: function (this: JQuery) {
      if (this.length <= 0) {
        // no objects in query
        return this;
      }

      const ta = this[0] as HTMLTextAreaElement;
      ta.style.overflow = 'hidden';
      ta.style.overflowWrap = 'break-word';

      const resize = () => {
        ta.style.height = '';
        ta.style.height =
          (ta.value === '' ? ta.style.lineHeight : ta.scrollHeight) + 'px';
      };

      this.on('input', () => {
        resize();
      });

      resize();

      return this;
    },
  });
};
export { addAutosizePlugin };
